module.exports = function getResource(label, vars = []) {
    let resources = {
        title: 'Beauty Insider Rewards'
    };

    return resources[label];
};
